export default {"src":"/uk/_next/static/media/podcastIcon.2ced2d97.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};